"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    Tablet: 768,
    Desktop: 1200,
};
